module.exports = require('./dist/lib/dynamic')



//////////////////
// WEBPACK FOOTER
// ./node_modules/next/dynamic.js
// module id = ./node_modules/next/dynamic.js
// module chunks = 6 9 11